import { css } from '@emotion/css';

export const saveButton = css`
  min-width: 4.9rem;
  height: 2.6rem;
  padding-inline-start: 0.8rem;
  padding-inline-end: 0.8rem;
`;
